import storage from "../Firebase";
import studentApiService from "../api/student-api-service";
import resourceApiService from "../api/resource-api-service";
import ClassApiService from "../api/classes-api-service";

const firebaseHelper = {
    deleteStudentPhoto: function (student) {
        console.log(`PROCESSING: ${student.photo}`)

        const task0 = storage.refFromURL(student.photo).delete()

        task0.then(() => {
            studentApiService.deletePhoto(student.id, student.created_by)
            console.log(`${student.photo} Photo deleted`)
        }).catch((error) => {
            console.log(`Firebase error: ${error}`)
            const url = `students/${student.created_by}/student_${student.id}`
            const task1 = storage.ref(url).delete()

            task1.then(() => {
                studentApiService.deletePhoto(student.id, student.created_by)
                console.log(`${url} Photo deleted`)
            }).catch((error) => {
                console.log(error)
                console.log(`Firebase error: ${error}`)
                const url = `students/${student.created_by}/student_${student.id}.jpg`
                const task2 = storage.ref(url).delete()

                task2.then(() => {
                    studentApiService.deletePhoto(student.id, student.created_by)
                    console.log(`${url} Photo deleted`)
                }).catch((error) => {
                    studentApiService.deletePhoto(student.id, student.created_by)
                    console.log(`Firebase error: ${error}`)
                });
            });
        });
    },

    deleteTeacherPhoto: function (teacher) {
        console.log(`PROCESSING: ${teacher.photo}`)

        const task0 = storage.refFromURL(teacher.photo).delete()

        task0.then(() => {
            resourceApiService.deleteTeacherPhoto(teacher)
            console.log(`${teacher.photo} Photo deleted`)
        }).catch((error) => {
            console.log(`Firebase error: ${error}`)
            const url = `students/${teacher.created_by}/student_${teacher.id}`
            const task1 = storage.ref(url).delete()

            task1.then(() => {
                resourceApiService.deleteTeacherPhoto(teacher)
                console.log(`${url} Photo deleted`)
            }).catch((error) => {
                console.log(error)
                console.log(`Firebase error: ${error}`)
                const url = `students/${teacher.created_by}/student_${teacher.id}.jpg`
                const task2 = storage.ref(url).delete()

                task2.then(() => {
                    resourceApiService.deleteTeacherPhoto(teacher)
                    console.log(`${url} Photo deleted`)
                }).catch((error) => {
                    // resourceApiService.deleteTeacherPhoto(teacher)
                    console.log(`Firebase error: ${error}`)
                    const url = `students/user_${teacher.created_by}/student_${teacher.id}.jpg`
                    const task3 = storage.ref(url).delete()
                    task3.then(() => {
                        resourceApiService.deleteTeacherPhoto(teacher)
                        console.log(`${url} Photo deleted`)
                    }).catch((error) => {
                        console.log(error)
                        console.log(`Firebase error: ${error}`)
                        const url = `students/user_${teacher.created_by}/student_${teacher.id}`
                        const task4 = storage.ref(url).delete()

                        task4.then(() => {
                            resourceApiService.deleteTeacherPhoto(teacher)
                            console.log(`${url} Photo deleted`)
                        }).catch((error) => {
                            resourceApiService.deleteTeacherPhoto(teacher)
                            console.log(`Firebase error: ${error}`)
                        });
                    });
                });
            });
        });
    },

    deleteWorkshopPhoto: function (yclass) {
        const task0 = storage.refFromURL(yclass.image_url).delete()
        yclass.image_url = "";

        task0.then(() => {
            ClassApiService.update(yclass.id, yclass)
        }).catch((error) => {
            console.log(`Firebase error: ${error}`)
            const url = `workshops/${yclass.created_by}/workshop_${yclass.id}`
            const task1 = storage.ref(url).delete()

            task1.then(() => {
                ClassApiService.update(yclass.id, yclass)
                console.log(`${url} Photo deleted`)
            }).catch((error) => {
                console.log(error)
                console.log(`Firebase error: ${error}`)
                const url = `workshops/${yclass.created_by}/workshop_${yclass.id}.jpg`
                const task2 = storage.ref(url).delete()

                task2.then(() => {
                    ClassApiService.update(yclass.id, yclass)
                    console.log(`${url} Photo deleted`)
                }).catch((error) => {
                    ClassApiService.update(yclass.id, yclass)
                    console.log(`Firebase error: ${error}`)
                });
            });
        });
    },
};

export default firebaseHelper;